// extracted by mini-css-extract-plugin
module.exports = {"HeroArticle":"styles_HeroArticle__SgG5G"};